import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {routing} from "./insights.routing";
import {CompaniesResolver} from "../shared/resolvers/companies.resolver";
import {UsersResolver} from "../shared/resolvers/users.resolver";
import {AuditsResolver} from "../shared/resolvers/audits.resolver";
import {FormsModule} from "@angular/forms";
import {ProfilesPerGeoComponent} from './profilesPerGeo/profilesPerGeo.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {ProfilesPerIpLevelComponent} from "./profilesPerIpLevel/profilesPerIpLevel.component";

@NgModule({
    imports : [
        BrowserModule,
        NgbModule.forRoot(),
        FormsModule,
        NgSelectModule,
        routing
    ],
    declarations : [
        ProfilesPerGeoComponent,
        ProfilesPerIpLevelComponent
    ],
    providers : [
        CompaniesResolver,
        UsersResolver,
        AuditsResolver
    ]
})

export class InsightsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/insights/insights.module.ts